/**
 * Check if two TransactionIndexes are equal
 *
 * @param {import('./TransactionIndexType.js').TransactionIndexType} a
 * @param {import('./TransactionIndexType.js').TransactionIndexType} b
 * @returns {boolean}
 */
export function equals(a, b) {
	return a === b;
}
